import Layout from "../components/Layout";
import Home from "./Home";
import Trials from "./Trials";
import Accounts from "./Accounts";
import Provision from "./Provision";
import Account from "./Account";
import Plans from "./Plans";
import RoleGuard from "../components/RoleGuard";
import { Route, Routes, useLocation } from "react-router-dom";
import { Users, Activity, Shield, Settings, CreditCard } from "lucide-react";

const navigationItems = [
  {
    title: "Leads",
    icon: Users,
    path: "/",
  },
  {
    title: "Trials",
    icon: Activity,
    path: "/trials",
  },
  {
    title: "Accounts",
    icon: Shield,
    path: "/accounts",
  },
  {
    title: "Provision",
    icon: Settings,
    path: "/provision",
  },
  {
    title: "Plans",
    icon: CreditCard,
    path: "/plans",
    adminOnly: true,
  },
];

// Create a wrapper component that uses useLocation inside the Router context
function PagesContent() {
  const location = useLocation();

  return (
    <Layout navigationItems={navigationItems} currentPath={location.pathname}>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/trials" element={<Trials />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route
          path="/provision"
          element={
            <RoleGuard requiredRole="super_admin">
              <Provision />
            </RoleGuard>
          }
        />
        <Route
          path="/plans"
          element={
            <RoleGuard requiredRole="super_admin">
              <Plans />
            </RoleGuard>
          }
        />
        <Route path="/:accountId/*" element={<Account />} />
      </Routes>
    </Layout>
  );
}

export default function Pages() {
  return <PagesContent />;
}
